import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const GuestsSection = () => {
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  // Reset zoom when image changes
  useEffect(() => {
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  }, [currentImageIndex]);

  // Prevent body scrolling and hide header when modal is open
  useEffect(() => {
    if (selectedCandidate) {
      // Save current scroll position
      const scrollY = window.scrollY;
      // Apply styles to prevent scrolling
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      // Add class to hide header
      document.body.classList.add('modal-open');
      
      return () => {
        // Restore scrolling when modal closes
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        // Remove class to show header
        document.body.classList.remove('modal-open');
        // Restore scroll position
        window.scrollTo(0, scrollY);
      };
    }
  }, [selectedCandidate]);

  // مرشحو الأمانة العامة (3 مرشحين)
  const generalSecretariatCandidates = [
    {
      id: 'secretariat_1',
      name: 'خلاد السوادي',
      currentPosition: 'عضو هيئة إدارية سابقة',
      images: [
        '/assets/المترشحين/الامانة العامة/2.jpg',
        '/assets/المترشحين/الامانة العامة/3.jpg',
      ]
    },
    {
      id: 'secretariat_2',
      name: 'ريبار بكر',
      currentPosition: 'نائب رئيس اتحاد جامعة أنقرة',
      images: [
        '/assets/المترشحين/الامانة العامة/4.jpg',
        '/assets/المترشحين/الامانة العامة/5.jpg',
        '/assets/المترشحين/الامانة العامة/6.jpg',
        '/assets/المترشحين/الامانة العامة/7.jpg',
      ]
    },
    {
      id: 'secretariat_3',
      name: 'محمد فرات الصالح',
      currentPosition: 'رئيس اتحاد جامعة إسطنبول',
      images: [
        '/assets/المترشحين/الامانة العامة/8.jpg',
        '/assets/المترشحين/الامانة العامة/9.jpg',
        '/assets/المترشحين/الامانة العامة/10.jpg',
        '/assets/المترشحين/الامانة العامة/11.jpg',
        '/assets/المترشحين/الامانة العامة/12.jpg'
      ]
    }
  ];

  // مرشحو الهيئة الإدارية (11 مرشح)
  const administrativeCandidates = [
    {
      id: 'admin_1',
      name: 'أحمد غزال',
      currentPosition: 'رئيس اتحاد جامعة إسطنبول',
      images: [
        '/assets/المترشحين/الهيئة الادارية 1/2.jpg',
        '/assets/المترشحين/الهيئة الادارية 1/3.jpg',
        '/assets/المترشحين/الهيئة الادارية 1/4.jpg'
      ]
    },
    {
      id: 'admin_2',
      name: 'أمجد محمد علي',
      currentPosition: 'عضو هيئة إدارية سابقة',
      images: [
        '/assets/المترشحين/الهيئة الادارية 1/5.jpg',
        '/assets/المترشحين/الهيئة الادارية 1/6.jpg',
        '/assets/المترشحين/الهيئة الادارية 1/7.jpg',
      ]
    },
    {
      id: 'admin_3',
      name: 'خالد ناصر',
      currentPosition: 'نائب رئيس اتحاد جامعة أنقرة',
      images: [
        '/assets/المترشحين/الهيئة الادارية 1/8.jpg',
        '/assets/المترشحين/الهيئة الادارية 1/9.jpg',
        '/assets/المترشحين/الهيئة الادارية 1/10.jpg',
      ]
    },
    {
      id: 'admin_4',
      name: 'روشان العبه جي',
      currentPosition: 'طالب دراسات عليا',
      images: [
        '/assets/المترشحين/الهيئة الادارية 1/11.jpg',
        '/assets/المترشحين/الهيئة الادارية 1/12.jpg',
      ]
    },
    {
      id: 'admin_5',
      name: 'سامر صالح',
      currentPosition: 'ناشط طلابي',
      images: [
        '/assets/المترشحين/الهيئة الادارية 2/2.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/3.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/4.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/5.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/6.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/7.jpg',
      ]
    },
    {
      id: 'admin_6',
      name: 'سيف الله خالد سنكري',
      currentPosition: 'طالب جامعي',
      images: [
        '/assets/المترشحين/الهيئة الادارية 2/8.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/9.jpg',
      ]
    },
    {
      id: 'admin_7',
      name: 'عمر بري',
      currentPosition: 'رئيس اتحاد محلي',
      images: [
        '/assets/المترشحين/الهيئة الادارية 2/10.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/11.jpg',
      ]
    },
    {
      id: 'admin_8',
      name: 'كوثر الخطيب',
      currentPosition: 'عضو مجلس إدارة',
      images: [
        '/assets/المترشحين/الهيئة الادارية 2/12.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/13.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/14.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/15.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/16.jpg',
        '/assets/المترشحين/الهيئة الادارية 2/17.jpg',
      ]
    },
    {
      id: 'admin_9',
      name: 'محمد خطاب',
      currentPosition: 'رئيس اتحاد طلابي',
      images: [
        '/assets/المترشحين/الهيئة الادارية  3/2.jpg',
        '/assets/المترشحين/الهيئة الادارية  3/3.jpg',
      ]
    },
    {
      id: 'admin_10',
      name: 'محمود حريتاني',
      currentPosition: 'نائب رئيس اتحاد',
      images: [
        '/assets/المترشحين/الهيئة الادارية  3/4.jpg',
        '/assets/المترشحين/الهيئة الادارية  3/5.jpg',
        '/assets/المترشحين/الهيئة الادارية  3/6.jpg',
        '/assets/المترشحين/الهيئة الادارية  3/7.jpg',
      ]
    },
    {
      id: 'admin_11',
      name: 'ياسين الخليل',
      currentPosition: 'عضو هيئة تنفيذية',
      images: [
        '/assets/المترشحين/الهيئة الادارية  3/8.jpg',
        '/assets/المترشحين/الهيئة الادارية  3/9.jpg',
        '/assets/المترشحين/الهيئة الادارية  3/10.jpg',
      ]
    }
  ];

  // مرشحو الهيئة الرقابية (12 مرشح)
  const supervisoryCandidates = [
    {
      id: 'super_1',
      name: 'أسامة حاج سليمان',
      currentPosition: 'طالب دراسات عليا',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 1/2.jpg',
      ]
    },
    {
      id: 'super_2',
      name: 'بيان عبدالله بيروتي',
      currentPosition: 'ناشط طلابي',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 1/3.jpg',
        '/assets/المترشحين/الهيئة الرقابية 1/4.jpg',
      ]
    },
    {
      id: 'super_3',
      name: 'جودي الهلال الشريفي',
      currentPosition: 'طالب جامعي',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 1/5.jpg',
        '/assets/المترشحين/الهيئة الرقابية 1/6.jpg',
        '/assets/المترشحين/الهيئة الرقابية 1/7.jpg',
        '/assets/المترشحين/الهيئة الرقابية 1/8.jpg',
      ]
    },
    {
      id: 'super_4',
      name: 'حسن مصطفى',
      currentPosition: 'رئيس اتحاد محلي',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 1/9.jpg',
        '/assets/المترشحين/الهيئة الرقابية 1/10.jpg',
        '/assets/المترشحين/الهيئة الرقابية 1/11.jpg',
        '/assets/المترشحين/الهيئة الرقابية 1/12.jpg'
      ]
    },
    {
      id: 'super_5',
      name: 'رجاء حسناتو',
      currentPosition: 'عضو مجلس إدارة',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 2/2.jpg',
        '/assets/المترشحين/الهيئة الرقابية 2/3.jpg',
        '/assets/المترشحين/الهيئة الرقابية 2/4.jpg',
      ]
    },
    {
      id: 'super_6',
      name: 'راكان مرعي',
      currentPosition: 'رئيس اتحاد طلابي',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 2/5.jpg',
        '/assets/المترشحين/الهيئة الرقابية 2/6.jpg',
        '/assets/المترشحين/الهيئة الرقابية 2/7.jpg',
      ]
    },
    {
      id: 'super_7',
      name: 'سعد نعناع',
      currentPosition: 'نائب رئيس اتحاد',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 2/8.jpg',
        '/assets/المترشحين/الهيئة الرقابية 2/9.jpg',
        '/assets/المترشحين/الهيئة الرقابية 2/10.jpg',
        '/assets/المترشحين/الهيئة الرقابية 2/11.jpg',
      ]
    },
    {
      id: 'super_8',
      name: 'عبد المنعم الحسن',
      currentPosition: 'عضو هيئة تنفيذية',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 2/12.jpg',
        '/assets/المترشحين/الهيئة الرقابية 2/13.jpg',
        '/assets/المترشحين/الهيئة الرقابية 2/14.jpg',
      ]
    },
    {
      id: 'super_9',
      name: 'محمد كمال الدين نعسان',
      currentPosition: 'طالب دراسات عليا',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 3/2.jpg',
        '/assets/المترشحين/الهيئة الرقابية 3/3.jpg',
      ]
    },
    {
      id: 'super_10',
      name: 'محمد أبرص',
      currentPosition: 'ناشط طلابي',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 3/4.jpg',
      ]
    },
    {
      id: 'super_11',
      name: 'محمد عامر صباغ',
      currentPosition: 'طالب جامعي',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 3/5.jpg',
        '/assets/المترشحين/الهيئة الرقابية 3/6.jpg',
      ]
    },
    {
      id: 'super_12',
      name: 'ميران يلماز أوغلو',
      currentPosition: 'رئيس اتحاد محلي',
      images: [
        '/assets/المترشحين/الهيئة الرقابية 3/7.jpg',
        '/assets/المترشحين/الهيئة الرقابية 3/8.jpg',
      ]
    }
  ];

  // مرشحو الهيئة العمومية (2 مرشح)
  const generalAssemblyCandidates = [
    {
      id: 'assembly_1',
      name: 'عبيدة دبلوني',
      currentPosition: 'طالب دراسات عليا',
      images: [
        '/assets/المترشحين/الهئية العمومية/2.jpg',
        '/assets/المترشحين/الهئية العمومية/3.jpg',
        '/assets/المترشحين/الهئية العمومية/4.jpg',
      ]
    },
    {
      id: 'assembly_2',
      name: 'قمر فاروسي',
      currentPosition: 'ناشط طلابي',
      images: [
        '/assets/المترشحين/الهئية العمومية/5.jpg',
        '/assets/المترشحين/الهئية العمومية/6.jpg'
      ]
    }
  ];

  const openModal = (candidate) => {
    setSelectedCandidate(candidate);
    setCurrentImageIndex(0);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const closeModal = () => {
    setSelectedCandidate(null);
    setCurrentImageIndex(0);
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const nextImage = () => {
    if (selectedCandidate) {
      setCurrentImageIndex((prev) => 
        prev === selectedCandidate.images.length - 1 ? 0 : prev + 1
      );
      setZoom(1);
      setPosition({ x: 0, y: 0 });
    }
  };

  const prevImage = () => {
    if (selectedCandidate) {
      setCurrentImageIndex((prev) => 
        prev === 0 ? selectedCandidate.images.length - 1 : prev - 1
      );
      setZoom(1);
      setPosition({ x: 0, y: 0 });
    }
  };

  const zoomIn = (e) => {
    e?.stopPropagation();
    setZoom((prev) => Math.min(prev + 0.2, 5));
  };

  const zoomOut = (e) => {
    e?.stopPropagation();
    setZoom((prev) => {
      const newZoom = Math.max(prev - 0.1, 1);
      if (newZoom === 1) {
        setPosition({ x: 0, y: 0 });
      }
      return newZoom;
    });
  };

  const resetZoom = () => {
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  const handleWheel = (e) => {
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault();
      const delta = e.deltaY > 0 ? -0.05 : 0.05;
      setZoom((prev) => {
        const newZoom = Math.max(1, Math.min(5, prev + delta));
        if (newZoom === 1) {
          setPosition({ x: 0, y: 0 });
        }
        return newZoom;
      });
    }
  };

  const handleMouseDown = (e) => {
    if (zoom > 1) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - position.x,
        y: e.clientY - position.y
      });
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging && zoom > 1) {
      const newX = e.clientX - dragStart.x;
      const newY = e.clientY - dragStart.y;
      
      // Constrain panning to prevent image from going too far off-screen
      const maxPan = 200 * zoom;
      setPosition({
        x: Math.max(-maxPan, Math.min(maxPan, newX)),
        y: Math.max(-maxPan, Math.min(maxPan, newY))
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const CandidateCard = ({ candidate, index, borderColor = 'primary' }) => {
    const borderClass = borderColor === 'primary' ? 'border-primary/20' : 'border-accent/20';
    
    return (
    <motion.div
      key={candidate.id}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="bg-card border border-border rounded-xl overflow-hidden shadow-memorial hover:shadow-lg transition-all duration-300 cursor-pointer"
      onClick={() => openModal(candidate)}
    >
      <div className="p-6">
        <div className="flex flex-col items-center text-center">
          {/* Candidate Photo */}
          <div className={`w-48 h-48 rounded-xl overflow-hidden mb-6 border-4 ${borderClass} mx-auto`}>
            <Image
              src={candidate.images[0] || '/assets/images/no_image.png'}
              alt={candidate.name}
              className="w-full h-full object-cover"
            />
          </div>
          
          {/* Candidate Name */}
          <h3 className="font-memorial text-xl md:text-2xl font-bold text-primary mb-4" dir="rtl">
            {candidate.name}
          </h3>
          

          {/* Image count indicator */}
          {candidate.images.length > 1 && (
            <div className="mt-4 flex items-center gap-2 text-text-secondary">
              <Icon name="Images" size={16} />
              <span className="font-body text-sm">{candidate.images.length} صور</span>
            </div>
          )}
        </div>
      </div>
    </motion.div>
    );
  };

  return (
    <section id="guests" className="relative py-16 lg:py-24 bg-gradient-to-b from-background via-[#114845]/5 to-background overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent"></div>
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-secondary/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="font-memorial text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6" dir="rtl">
            رواد المرحلة القادمة: تعرّف على المرشحين
          </h2>
          <p className="font-body text-lg md:text-xl text-text-primary leading-relaxed max-w-3xl mx-auto" dir="rtl">
            نضع بين أيديكم القائمة النهائية للمرشحين الذين تقدموا لتحمل المسؤولية للدورة الثانية (2026-2027).
          </p>
        </motion.div>

        {/* Section 1: الأمانة العامة */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mb-16"
        >
          <div className="flex items-center gap-4 mb-8">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-border to-border"></div>
            <h3 className="font-memorial text-2xl md:text-3xl font-bold text-primary" dir="rtl">
              أولاً: مرشحو الأمانة العامة
            </h3>
            <div className="flex-1 h-px bg-gradient-to-l from-transparent via-border to-border"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {generalSecretariatCandidates.map((candidate, index) => (
              <CandidateCard key={candidate.id} candidate={candidate} index={index} borderColor="primary" />
            ))}
          </div>
        </motion.div>

        {/* Section 2: الهيئة الإدارية */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-16"
        >
          <div className="flex items-center gap-4 mb-8">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-border to-border"></div>
            <h3 className="font-memorial text-2xl md:text-3xl font-bold text-primary" dir="rtl">
              ثانياً: مرشحو الهيئة الإدارية (مجلس الإدارة)
            </h3>
            <div className="flex-1 h-px bg-gradient-to-l from-transparent via-border to-border"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {administrativeCandidates.map((candidate, index) => (
              <CandidateCard key={candidate.id} candidate={candidate} index={index} borderColor="primary" />
            ))}
          </div>
        </motion.div>

        {/* Section 3: الهيئة الرقابية */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mb-16"
        >
          <div className="flex items-center gap-4 mb-8">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-border to-border"></div>
            <h3 className="font-memorial text-2xl md:text-3xl font-bold text-primary" dir="rtl">
              ثالثاً: مرشحو الهيئة الرقابية
            </h3>
            <div className="flex-1 h-px bg-gradient-to-l from-transparent via-border to-border"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {supervisoryCandidates.map((candidate, index) => (
              <CandidateCard key={candidate.id} candidate={candidate} index={index} borderColor="accent" />
            ))}
          </div>
        </motion.div>

        {/* Section 4: الهيئة العمومية */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mb-12"
        >
          <div className="flex items-center gap-4 mb-8">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-border to-border"></div>
            <h3 className="font-memorial text-2xl md:text-3xl font-bold text-primary" dir="rtl">
              رابعاً: مرشحو الهيئة العمومية
            </h3>
            <div className="flex-1 h-px bg-gradient-to-l from-transparent via-border to-border"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {generalAssemblyCandidates.map((candidate, index) => (
              <CandidateCard key={candidate.id} candidate={candidate} index={index} borderColor="accent" />
            ))}
          </div>
        </motion.div>

        {/* Note Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-12"
        >
          <div className="bg-gradient-to-r from-primary/10 via-accent/10 to-success/10 border border-primary/20 rounded-lg p-6 md:p-8">
            <div className="flex items-start gap-4">
              <Icon name="Info" size={24} className="text-primary flex-shrink-0 mt-1" />
              <p className="font-body text-base md:text-lg text-text-primary leading-relaxed" dir="rtl">
                <span className="font-semibold">ملاحظة:</span> للاطلاع على البرامج الانتخابية التفصيلية، يمكنكم زيارة حساباتنا على وسائل التواصل الاجتماعي.
              </p>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Image Modal */}
      <AnimatePresence>
        {selectedCandidate && (
          <>
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={closeModal}
              className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
            >
              {/* Modal Content */}
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                onClick={(e) => e.stopPropagation()}
                className="relative bg-card rounded-xl max-w-4xl w-full max-h-[90vh] overflow-hidden shadow-2xl"
              >
                {/* Close Button */}
                <button
                  onClick={closeModal}
                  className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
                  aria-label="Close"
                >
                  <Icon name="X" size={24} />
                </button>

                {/* Image Container */}
                <div 
                  className={`relative w-full h-[70vh] flex items-center justify-center bg-background overflow-hidden ${
                    zoom > 1 ? 'cursor-grab active:cursor-grabbing' : 'cursor-default'
                  }`}
                  onWheel={handleWheel}
                  onMouseDown={handleMouseDown}
                  onMouseMove={handleMouseMove}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseUp}
                >
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={currentImageIndex}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="absolute inset-0 flex items-center justify-center p-8"
                    >
                      <div
                        style={{
                          transform: `translate(${position.x}px, ${position.y}px) scale(${zoom})`,
                          transformOrigin: 'center center',
                          transition: isDragging ? 'none' : 'transform 0.1s ease-out',
                          willChange: 'transform'
                        }}
                      >
                        <Image
                          src={selectedCandidate.images[currentImageIndex]}
                          alt={`${selectedCandidate.name} - Image ${currentImageIndex + 1}`}
                          className="max-w-[90vw] max-h-[60vh] object-contain select-none"
                          style={{ 
                            display: 'block'
                          }}
                          draggable={false}
                        />
                      </div>
                    </motion.div>
                  </AnimatePresence>

                  {/* Zoom Controls */}
                  <div 
                    className="absolute top-4 left-4 flex flex-col gap-2 z-20"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      onClick={zoomIn}
                      className="bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      aria-label="Zoom in"
                      disabled={zoom >= 5}
                    >
                      <Icon name="Plus" size={20} />
                    </button>
                    <button
                      onClick={zoomOut}
                      className="bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      aria-label="Zoom out"
                      disabled={zoom <= 1}
                    >
                      <Icon name="Minus" size={20} />
                    </button>
                    {zoom > 1 && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          resetZoom();
                        }}
                        className="bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
                        aria-label="Reset zoom"
                      >
                        <Icon name="RefreshCw" size={20} />
                      </button>
                    )}
                  </div>

                  {/* Navigation Arrows */}
                  {selectedCandidate.images.length > 1 && (
                    <>
                      {/* Left Arrow */}
                      <button
                        onClick={prevImage}
                        className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-3 transition-colors z-10"
                        aria-label="Previous image"
                        style={{ marginLeft: zoom > 1 ? '60px' : '0' }}
                      >
                        <Icon name="ChevronLeft" size={24} />
                      </button>

                      {/* Right Arrow */}
                      <button
                        onClick={nextImage}
                        className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-3 transition-colors z-10"
                        aria-label="Next image"
                      >
                        <Icon name="ChevronRight" size={24} />
                      </button>
                    </>
                  )}

                  {/* Image Counter */}
                  {selectedCandidate.images.length > 1 && (
                    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/50 text-white px-4 py-2 rounded-full text-sm font-body z-10">
                      {currentImageIndex + 1} / {selectedCandidate.images.length}
                    </div>
                  )}

                  {/* Zoom Level Indicator */}
                  {zoom > 1 && (
                    <div className="absolute top-4 right-4 bg-black/50 text-white px-3 py-1 rounded-full text-sm font-body z-10">
                      {Math.round(zoom * 100)}%
                    </div>
                  )}
                </div>

                {/* Candidate Info */}
                <div className="p-6 border-t border-border" dir="rtl">
                  <h3 className="font-memorial text-2xl font-bold text-primary mb-2">
                    {selectedCandidate.name}
                  </h3>
                </div>
              </motion.div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </section>
  );
};

export default GuestsSection;
